module.exports = __webpack_public_path__ + "static/img/good3.2e3a260b.png";